export default "__VITE_ASSET__B1yW0rA9__"